import axios from 'axios';

export const getLocationFromZipcode = async (zipcode) => {
    const url = `https://api.mapbox.com/geocoding/v5/mapbox.places/${zipcode}.json?access_token=${window.MAPBOX_API_KEY}&country=US&limit=1`;
    const response = await axios.get(url);
    if (response.status === 200) {
        return response.data.features[0];
    }

    return null;
};
